const chromeExtensionID = 'djidapogageiehhmihamgimggepbnojp';
const safariExtensionID = 'Wildfire-Systems.Givebacks-DSE.Extension (UNSIGNED)';

const chromeWebsStore = `https://chrome.google.com/webstore/detail/givebacks/${chromeExtensionID}`;
// const sfExtensionID = "com.givebacks.mac.Extension (team_identifier)";

const defaultErrorMessage = 'There was an error. Please try again later.';

enum AppLinks {
  android_scheme = 'com.givebacks://native',
  wallet = 'com.givebacks://Wallet',
  android_play_store = 'https://play.google.com/store/apps/details?id=com.givebacks',
  android_market = 'market://launch?id=com.givebacks',
  appStore = 'https://apps.apple.com/us/app/givebacks/id1612867868',
}

enum ExternalUrls {
  secure_card_faq = 'https://support.givebacks.com/hc/en-us/articles/5998873533847',
}
const appRoutes = {
  'auth.session': '/auth/session',
  offers: '/offers',
  'offers.local': '/offers/local',
  causes: '/causes',

  cause: (route: string) => `/causes/${route}`,
  campaign: (causeId: string, campaignId: string) => `/causes/${causeId}/campaigns/${campaignId}`,
  event: (causeId: string, eventId: string) => `/causes/${causeId}/events/${eventId}`,
  participantCenter: (causeId: string, campaignId: string) =>
    `/causes/${causeId}/campaigns/${campaignId}/participant-center`,
  campaignRegistration: (causeId: string, campaignId: string) =>
    `/causes/${causeId}/campaigns/${campaignId}/participant-center/register`,
  shopStore: (storeId: string, storeItemId?: string) =>
    `/shop/stores/${storeId}${storeItemId ? `/items/${storeItemId}` : ''}`,

  NPO_ADMIN_EVENT_SCAN: (params: { causeId: string; eventId: string; eventDateId: string }) =>
    `/npo-admin/events/${params.eventId}/event-date/${params.eventDateId}/access-code?cause_id=${params.causeId}`,
};

export const Constants = {
  chromeExtensionID,
  safariExtensionID,
  AppLinks,
  chromeWebsStore,
  defaultErrorMessage,
  ExternalUrls,
  appRoutes,
};
